import type { BlurLevel } from 'webRTC/types';

export type MediaTrackErrorKey = 'deviceAlreadyInUse' | 'notReadableError' | 'permissionDenied' | 'unexpectedError';

export type MediaSettingsState = {
  videoDeviceId: string;
  audioInputDeviceId: string;
  audioOutputDeviceId: string;
  blurLevel: BlurLevel;
  /**
   * Id of the selected image background from `VIDEO_BACKGROUNDS`, or `''` for none.
   *
   * A sibling of `blurLevel` rather than a replacement: blur has other consumers (Health Check, the
   * broadcast Stage Invitation) that don't offer image backgrounds. An image wins over blur when both
   * are set, and the picker is the only thing that writes either, so they can't drift.
   */
  backgroundImageId: string;
};

export type MediaDevice = Pick<MediaDeviceInfo, 'deviceId' | 'groupId' | 'kind' | 'label'>;

export enum MediaSettingsTab {
  Video,
  Audio,
}
